import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import t from 'common/i18n';
import { addNotification } from 'root/actions';
import notifications, { NOTIFICATION_IDS } from 'root/data/NotificationsData';
import ServiceLoginIntro from 'root/components/ServiceLoginIntro';
import TabProgress from 'root/components/Progress/TabProgress';
import appConfig from 'appConfig';
import { getInternalPath } from '../utils';
import SVG_ICONS from '~/assets/icons/icons';

const introFooter = (source) => (
  <a className="c-link" href={appConfig[source].registrationLink} target="_blank" rel="noopener noreferrer">
    {t(`${source}.reg_link_text`)}
  </a>
);

export default ({ handleLoginAction, source, service, onAuthActionClick, cloudName, isAuthInProgress }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    service()
      .setAuthListener(cloudName)
      .then((result) => {
        dispatch(handleLoginAction({ token: result }));
        const path = getInternalPath(source);
        if (history.location.pathname !== path) {
          history.push(path);
        }
      })
      .catch(() => {
        addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
      });
  }, [dispatch, cloudName, handleLoginAction, history, source, service]);

  return (
    <>
      <ServiceLoginIntro
        key={`${source}_login_intro`}
        title={t(`${source}.no_auth_title`)}
        actionTitle={t(`${source}.no_auth_action`)}
        statement={t(`${source}.no_auth_statement`)}
        btnIcon={SVG_ICONS[source.toUpperCase()]}
        btnClass="btn-drive"
        actionHandler={onAuthActionClick}
        footer={introFooter(source)}
      />
      {isAuthInProgress && <TabProgress />}
    </>
  );
};
